import {
  apiRoutes,
  type AxiosRequestConfig,
  type DefaultQueryError,
  DeliveryType,
  httpClient,
  type Service,
  type ServiceTypesParams,
} from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { stringify } from 'qs';

const ACCEPTS_VERSION = 6;

export const getServiceTypesFn = async (
  params: ServiceTypesParams,
  config: AxiosRequestConfig = {}
) => {
  const acceptsVersion: number =
    typeof config.headers?.['accepts-version'] === 'number'
      ? config.headers['accepts-version']
      : params.delivery_type === DeliveryType.Nationwide
        ? 3
        : 2;

  const response = await httpClient.get<Service[]>(
    apiRoutes.service.serviceTypes,
    {
      params,
      ...config,
      headers: {
        ...(config.headers ?? {}),
        'accepts-version': acceptsVersion,
      },
      paramsSerializer: (p) => stringify(p, { arrayFormat: 'repeat' }),
    }
  );
  return response.data;
};

export const useGetServiceTypes = (
  params: ServiceTypesParams,
  opts?: Omit<UseQueryOptions<Service[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<Service[], DefaultQueryError>({
    queryKey: [apiRoutes.service.serviceTypes, params],
    queryFn: ({ signal }) =>
      getServiceTypesFn(params, {
        signal,
        headers: { 'accepts-version': ACCEPTS_VERSION },
      }),
    ...opts,
  });
